export default __webpack_public_path__ + "static/media/feedback.df45e2d3.png";